import type { Subscription } from '../../../types';

import select from '../../../helpers/data/select-subscription';
import useData from '@blueshift-ui/fetch/dist/hooks/use-data';

interface UsePlanPreviewProps {
  currentSubscription: Subscription;
  newSubscription: Subscription | null;
  previewEndDate: string | any;
  scheduledAt: string | null;
}

function usePlanPreview({
  currentSubscription,
  newSubscription,
  previewEndDate,
  scheduledAt,
}: UsePlanPreviewProps) {
  const body = scheduledAt
    ? {
        transform_requests: [
          {
            scheduled_at: scheduledAt,
            transformation_type: 'membership_change_requested',
            parameters: {
              new_item_id: newSubscription?.item_id,
              old_item_id: currentSubscription.item_id,
              new_purchase_price_cents: currentSubscription.purchase_price_cents,
              old_purchase_price_cents: newSubscription?.purchase_price_cents,
            },
          },
        ],
      }
    : null;

  return useData<Subscription | null>({
    queryKey: ['planPreview', currentSubscription.id],
    queryOptions: {
      select,
    },
    request: {
      body,
      method: 'POST',
      params: {
        at: new Date(previewEndDate).toISOString(),
      },
      url: `/v1/subscriptions/${currentSubscription.id}/preview`,
    },
  });
}

export default usePlanPreview;
